import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class NewsUrn {
  headline = ""
  story = ""
}

export const NEWS_URN_DESER: SchemaDeSer<NewsUrn> = new SchemaDeSerBuilder(
  NewsUrn
)
  .ofString("headline")
  .ofString("story")
  .toDeSer()

export class NewsItem {
  attribution = ""
  createdAt = ""
  headline = ""
  id = ""
  language = ""
  provider = ""
  revision = 0
  updatedAt = ""
  urgency = ""
}

export const NEWS_ITEM_DESER: SchemaDeSer<NewsItem> = new SchemaDeSerBuilder(
  NewsItem
)
  .ofStrings(
    "attribution",
    "createdAt",
    "headline",
    "id",
    "language",
    "provider",
    "revision"
  )
  .ofInt("revision")
  .ofStrings("updatedAt", "urgency")
  .toDeSer()

export class TopNewsItem {
  id = ""
  headline = ""
  createdAt: Date | null = null
  dateline = ""
  summary = ""
  imageAltText = ""
  thumbnailImageUrl = ""
  viewImageUrl = ""
}

export class TopNewsStory {
  headline = ""
  text = ""
}

export const TOP_NEWS_STORY_DESER: SchemaDeSer<TopNewsStory> =
  new SchemaDeSerBuilder(TopNewsStory).ofStrings("headline", "text").toDeSer()

export const TOP_NEWS_ITEM_DESER: SchemaDeSer<TopNewsItem> =
  new SchemaDeSerBuilder(TopNewsItem)
    .ofStrings(
      "id",
      "headline",
      "dateline",
      "summary",
      "imageAltText",
      "thumbnailImageUrl",
      "viewImageUrl"
    )
    .ofDateTime("createdAt")
    .toDeSer()
